import { queryOptions, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { FIFTEEN_MINUTES, QUERY_KEYS } from '@avanta/shared/constants/common';
import { PatientService } from '@avanta/shared/services/patients';
import { type AppQueryOptions } from '@avanta/shared/types/queries';
import { type User } from '@avanta/shared/types/users';

export const fetchPatientQueryOptions = (
  patientId?: string
): AppQueryOptions<User, readonly [typeof QUERY_KEYS.FETCH_PATIENT, string | undefined]> =>
  queryOptions({
    queryKey: [QUERY_KEYS.FETCH_PATIENT, patientId] as const,
    queryFn: async () => (await PatientService.getPatient(patientId)).data,
    staleTime: FIFTEEN_MINUTES,
    gcTime: FIFTEEN_MINUTES,
  });

export const useFetchPatient = (patientId?: string): UseQueryResult<User | undefined, Error> =>
  useQuery({
    ...fetchPatientQueryOptions(patientId),
    enabled: !!patientId,
  });
